import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { HttpHeaders } from '@angular/common/http';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { ExcelService } from 'src/app/services/excel.service';
import { DRSService } from 'src/app/services/operations/drs.service';

@Component({
    selector: 'app-upload-copy',
    templateUrl: './upload-copy.component.html',
    styleUrls: ['./upload-copy.component.scss']
})

export class UploadDRSCopyComponent implements OnInit {
    modalForm: FormGroup;
    selectedFile: File | null = null;
    @Input() importType = new EventEmitter<any[]>();
    @Input() selectedSCId = new EventEmitter<number>();
    showProgressBar = false;
    progress: number = 0;
    drsId: number;

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private utilities: Utilities,
        private _fb: FormBuilder,
        private fileHandlerService: FileHandlerService,
        private drsService: DRSService,
        private excelService: ExcelService
    ) { }

    ngOnInit() {
        this.modalForm = this._fb.group({
            txtFile: [],
            txtFileId: []
        });
    }

    onChangeFileSelect(evt: any) {
        try {
            if (evt) {
                this.selectedFile = evt.target.files[0];
            }
        } catch (e) {
            console.error(e);
        }
    }

    uploadFile() {
        try {
            let interval: any;
            let timeout: any;
            clearInterval(interval);
            clearTimeout(timeout);
            if (this.selectedFile) {
                let requestObj = {
                    name: this.selectedFile.name,
                    fileType: this.selectedFile.type,
                    category: 'drs-upload'
                };
                this.showProgressBar = true;
                this.progress = 0;
                interval = setInterval(() => {
                    if (this.progress < 99) {
                        this.progress += 1;
                    }
                }, 100);
                timeout = setTimeout(() => {
                    if (this.progress >= 99 && this.progress < 100) {
                        this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                        this.showProgressBar = false;
                        clearInterval(interval);

                    }
                }, 5000);

                this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                    try {
                        if (res && res.success) {
                            const signedUrl = res.data.uploadURL;
                            const fileId = res.data.fileId;
                            if (signedUrl) {
                                let headers: HttpHeaders = new HttpHeaders({
                                    "Content-Type": requestObj.fileType
                                });

                                this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                                    if (f === null) {
                                        this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                            if (res && res.success) {
                                                this.progress = 100;
                                                this.saveFileIdInDrs(fileId, this.selectedSCId);
                                                clearInterval(interval);
                                                clearTimeout(timeout);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                    catch (error) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        this.showProgressBar = false;
                        console.error(error);
                    }
                });
            } else {
                this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
            }
        } catch (error) {
            console.error(error);
        }
    }

    saveFileIdInDrs(fileId?: any,selectedSCId?: any) {
        try {
            const requestObj = {
                drsId: this.drsId,
                fileId: fileId,
                selectedSCId: selectedSCId
            }
            this.drsService.updateFileIdInDrs(requestObj).subscribe((res) => {
                if (res && res.success) {
                    this.showProgressBar = false;
                    this.activeModal.close('Upload Successful');
                    this.appCoreService.showMessage('Upload Successful');
                }
                if (res && !res.success) {
                    this.showProgressBar = false;
                    this.activeModal.dismiss();
                    this.appCoreService.showMessage(res.message,'Error', 'error');
                }
            })
        } catch (error) {
            console.error(error);
        }
    }
}